/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FaceASadIcon24Solid = forwardRef('FaceASadIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-3.547-5.47c.404-1.401 1.86-2.486 3.547-2.486s3.142 1.085 3.547 2.486a1 1 0 1 0 1.921-.555c-.675-2.34-2.98-3.93-5.468-3.93-2.489 0-4.793 1.59-5.469 3.93a1 1 0 1 0 1.922.555Z" })));
});
